import axios from 'axios';

const backendBaseUrl = process.env.REACT_APP_BACKEND_URL;

let allProducts = null;

async function fetchProducts() {
    try {
        const response = await axios.get(backendBaseUrl + "products/?currency=" + localStorage.getItem('selectedCurrency'));
        allProducts = parseProductsData(response.data);
    }    
    catch (error) {
        alert(error);
        allProducts = [];
    }
}

async function fetchProductDetails(id, name){
    try {
        const response = await axios.get(backendBaseUrl + "productDetails/" + id + "?currency=" + localStorage.getItem('selectedCurrency'));
        const responseData = response.data;
        const parsedPrices = parseProductPrices(responseData.productPrices);
        const { parsedDataOptions, parsedColors, parsedToyColor} = parseProductOptions(responseData.productDetails[0].options, response.data.allProductOptions, name.split('-')[0]);
        const productDetails = parseProductDetails(responseData.productDetails, parsedPrices, parsedDataOptions, parsedColors, parsedToyColor);
        return productDetails;
    }    
    catch (error) {
        alert(error);
        return [];
    }
}

async function getAllProducts() {
    if (allProducts == null){
        await fetchProducts();
    }

    return allProducts;
}

async function getSortedProductsByCategory(categoryIds) {
    const allProducts = await getAllProducts();  // Await the asynchronous call
    const mappedProducts = new Map();
    categoryIds.forEach(categoryId => {
        let productsInCategory = allProducts.filter(
            function(product) {
                return product.typeId === categoryId;
            }
        )
        .sort(function(a, b) {
            return a.id - b.id; // Ascending order
        });
        mappedProducts.set(categoryId, productsInCategory);
    });

    return mappedProducts;
}

function orderImageUrls(data){
    let imagesUrlArray = [
        data.specialUrl, data.specialViewUrl, data.normalUrl, data.normalViewUrl, data.miniUrl, data.smallUrl, data.mediumUrl, data.largeUrl, data.xLargeUrl
    ];
    
    imagesUrlArray = imagesUrlArray.filter(function(element) {
        return element !== null && element !== undefined && element !== "";
    });

    return imagesUrlArray;
}

const slugify = (text) =>
    text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')        // Replace spaces with -
      .replace(/[^\w\-]+/g, '')    // Remove all non-word chars
      .replace(/\-\-+/g, '-');     // Replace multiple - with single -
  
  async function getProductInfo(slug) {
    if (allProducts == null) {
      await fetchProducts();
    }
  
    const array = allProducts;
  
    for (let i = 0; i < array.length; i++) {
      const productSlug = slugify(array[i].name);
      if (productSlug === slug) {
        return array[i];
      }
    }
  }
  
  

async function getProductDetail(id, name){
    let productDetails = await fetchProductDetails(id, name);

    return productDetails[0];
}

function parseProductsData(data){
    let parsedData = [];
    
    data.forEach(element => {
        parsedData.push({
            id: element.stripeID,
            name: element.name,
            nameFR: element.nameFR,
            description: element.description,
            descriptionFR: element.descriptionFR,
            previewUrl : element.previewUrl,
            typeId: element.typeId,
            price: (element.productPrices.price/100).toFixed(2),
            priceCAD: (element.productPrices.priceCAD/100).toFixed(2),
            story: element.story,
            storyFR: element.storyFR,
            hsCode: element.hsCode,
            //cc as in original country
            oc: element.originalCountry,
            // ed as in export description
            ed: element.exportDescription
        });
    });

    return parsedData;
}

function parseProductDetails(data, dataPrices, productOptions, productColors, parsedToyColor){
    let parsedData = [];
    data.forEach(element => {
        let sortedDataPrices = dataPrices.sort((a, b) => a.price - b.price);
        let sortedProductOptions = productOptions.sort((a, b) => a.price - b.price);
        // Keep any "Mystery" color(s) at the end, sort others by creation date (newest first)
        const mysteryColors = productColors.filter(c => c.description === "Mystery");
        const otherColors = productColors.filter(c => c.description !== "Mystery");

        otherColors.sort((a, b) => {
            const dateA = a.created_at ? new Date(a.created_at) : new Date(0);
            const dateB = b.created_at ? new Date(b.created_at) : new Date(0);
            return dateA - dateB; // newest first
        });

        let sortedProductColors = [...otherColors, ...mysteryColors];

        let sortedToyColors = parsedToyColor.sort((a, b) => a.price - b.price);

        // Extract all splitFirm options
        const extractedFirmnessOptions = sortedProductOptions.filter(
            option => option.sizeRef === "splitFirm"
        );
    
        // Remove extracted firmness options from main options list
        sortedProductOptions = sortedProductOptions.filter(
            option => option.sizeRef !== "splitFirm"
        );

        parsedData.push({
            availableFirmness: element.availableFirmness,
            availableSizes: sortedDataPrices,
            availableCustomFirmness: extractedFirmnessOptions,
            availableOptions: sortedProductOptions,
            availableColors: sortedProductColors,
            availableThemedColors: sortedToyColors,
            imageUrls: orderImageUrls(element),
            weight: element.weight,
            dimensions: element.sizes,
            isCustom: element.isCustom,
        });
    });
    
    return parsedData;
}

function parseProductOptions(productDataOptions, allDataOptions, nameStart){
    let parsedDataOptions = [];
    let parsedColors = [];
    let parsedToyColor = [];

    for (let option of allDataOptions) {
        if (option.sizeRef.startsWith(`color-${nameStart}-`)){
            option.price = (option.price/100).toFixed(2);
            option.priceCAD = (option.priceCAD/100).toFixed(2);
            parsedToyColor.push(option);
        }
        
        if (option.sizeRef.match(/^color-[a-zA-Z]+$/)){
            option.price = (option.price/100).toFixed(2);
            option.priceCAD = (option.priceCAD/100).toFixed(2);
            parsedColors.push(option);
        }

        if (productDataOptions?.includes(option.sizeRef)){
            option.price = (option.price/100).toFixed(2);
            option.priceCAD = (option.priceCAD/100).toFixed(2);
            parsedDataOptions.push(option);
        }
    }

    return ({parsedDataOptions, parsedColors, parsedToyColor});
}

function parseProductPrices(data){
    let parsedData = [];
    const sizeOrder = ["XS", "S", "M", "L", "XL"];
    data.forEach(element => {
        parsedData.push({
            id: element.stripeID,
            description: element.description,
            price: (element.price/100).toFixed(2),
            priceCAD: (element.priceCAD/100).toFixed(2),
            sizeRef: element.sizeRef,
        });
    });

    parsedData.sort((a, b) => {
        return sizeOrder.indexOf(a.sizeRef) - sizeOrder.indexOf(b.sizeRef);
    });

    return parsedData;
}

export {getAllProducts, getSortedProductsByCategory, getProductDetail, getProductInfo};
